import UserLobbyView from 'UserLobby/views/UserLobbyView';

export default UserLobbyView;
